import React from "react";
import { Routes, Route } from "react-router-dom";
import ScrollToTopOnMount from "../../../ScrollToTop";
import ForumsTable from "./ForumsTable";
import ForumTopics from "./ForumTopics";
import ForumTicket from "./ForumTicket";
import PageContainer from "../../common/PageContainer";

export default function Forums() {
    return (
        <>
            <ScrollToTopOnMount />
            <PageContainer>
                <Routes>
                    <Route path="/" element={<ForumsTable />} />
                    <Route path="/topic/:topicId" element={<ForumTopics />} />
                    <Route path="/topic/:topicId/ticket/:ticketId" element={<ForumTicket />} />
                </Routes>
            </PageContainer>
        </>
    );
}
